import { BodyTitle, H2 } from '@justomx/atlas-design-system'
import { useTranslation } from 'react-i18next'
import { BrFlagAtom } from 'design-system/atom/BrFlag.atom'
import { MxFlagAtom } from 'design-system/atom/MxFlag.atom'
import { PeFlagAtom } from 'design-system/atom/PeFlag.atom'
import { type Country, isCountry } from '../../internal-types/country.type'

interface CountryData {
  id: Country
  icon: JSX.Element
}

const countries: CountryData[] = [
  { id: 'MX', icon: <MxFlagAtom /> },
  { id: 'BR', icon: <BrFlagAtom /> },
  { id: 'PE', icon: <PeFlagAtom /> }
]

export type SelectCountryAtomProps = {
  country: string | undefined
  setCountry: (value: Country) => void
}
export function SelectCountryMolecule({
  setCountry,
  country: selectedCountry
}: SelectCountryAtomProps) {
  const { t } = useTranslation('global')
  const onChange = (country: string) => {
    if (isCountry(country)) {
      setCountry(country)
    }
  }

  return (
    <div className="flex flex-col gap-9">
      <H2 className="text-center">{t('select-country.title')}</H2>

      <div className="flex flex-col gap-4">
        {countries.map((country) => (
          <div
            key={country.id}
            className={`p-4 rounded-xl border ${country.id === selectedCountry ? 'border-primary' : 'border-[#424242]'}`}
            onClick={() => {
              onChange(country.id)
            }}
          >
            <BodyTitle className="flex flex-row items-center gap-4">
              {country.icon} {t(`select-country.${country.id}`)}
            </BodyTitle>
          </div>
        ))}
      </div>
    </div>
  )
}
